// extracted by mini-css-extract-plugin
module.exports = {"count":"Count_count__1RtFA","inverted":"Count_inverted__35uaK"};